import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space } from 'antd'
import { ManufacturData } from 'Store/minirmx-dashboard/types'
import { PdfPrintFormat } from 'Components/form'
import { numberWithComma } from 'helpers/format'
import { MerchantData } from 'Store/user/types'
import PdfCompanyInfo from 'Pages/Purchase/components/PdfCompanyInfo'

type Props = {
  detail?: ManufacturData
  merchant?: MerchantData
}

const CompareReportPDF: React.FunctionComponent<Props> = props => {
  const { detail, merchant } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderInfoItem = (title: any, value: any, justify: 'start' | 'end' = 'start') => {
    return (
      <Row gutter={[8, 8]} justify={justify}>
        <Col>
          <Space wrap={true}>
            <InfoTitle>
              {title} : {value || '-'}
            </InfoTitle>
          </Space>
        </Col>
      </Row>
    )
  }

  const tableHeader = (
    <thead>
      <tr>
        <th colSpan={8}>
          <TableTitle>ใบแสดงส่วนผสมการผลิต (โดยประมาณ)</TableTitle>
        </th>
      </tr>
      <tr>
        <th rowSpan={2}>MIX NO.</th>
        <th rowSpan={2}>
          Concrete Volume <br />
          (m<sup>3</sup>)
        </th>
        <th rowSpan={2}>
          STRENGTH (Kg/cm<sup>2</sup>) <br /> AT 28 DAYS <br /> CUBE <br /> 15X15X15 (cm)
        </th>
        <th colSpan={4}>APPROXIMATE PROPORTION</th>
        <th rowSpan={2} colSpan={4} style={{ width: '150px' }}>
          REMARK
        </th>
      </tr>
      <tr>
        <th>
          CEMENT MATERIALS <br /> (kg)
        </th>
        <th>
          SAND <br /> (kg)
        </th>
        <th>
          ROCK <br /> (kg)
        </th>
        <th>
          WATER <br /> (Litre)
        </th>
      </tr>
    </thead>
  )

  const tableBody = (
    <tbody>
      <tr>
        <td>{renderInfo('1')}</td>
        <td>{`${detail?.quantity}`}</td>
        <td>{`${detail && detail['class']}`}</td>
        <td>{renderInfo(numberWithComma(detail?.cement || 0))}</td>
        <td>{renderInfo(numberWithComma(detail?.sand || 0))}</td>
        <td>{renderInfo(numberWithComma(detail?.rock || 0))}</td>
        <td>{renderInfo(numberWithComma(detail?.water || 0))}</td>
        <td colSpan={4}></td>
      </tr>
    </tbody>
  )

  const renderCustomerInfo = () => {
    return (
      <div>
        {renderInfoItem('ชื่อร้านค้า', merchant?.name)}
        {renderInfoItem('ที่อยู่', merchant?.address)}
        {renderInfoItem('เบอร์โทรศัพท์', merchant?.phone)}
      </div>
    )
  }

  return (
    <BoxWrapper>
      <Row>
        <Col span={24}>
          <PdfPrintFormat
            companyInfo={<PdfCompanyInfo merchant={merchant} hasFullAddress={true} />}
            //companyInfo={<span></span>}
            title={''}
            leftInfo={<span></span>}
            rightInfo={<span></span>}
            footerSpan={9}
            summaryFooter={
              <RemarkWrapper>
                {renderInfoItem(
                  'หมายเหตุ',
                  'ข้อมูลปริมาณ ปูนซีเมนต์, หิน, ทราย และ น้ำ จากรายงานที่ออกโดยระบบ Mini RMX iTrack ใช้สำหรับการคำนวน Mix Design เท่านั้น บริษัทไม่รับรองและไม่มีความรับผิดใดต่อความถูกต้องและสมบูรณ์ของข้อมูล หรือการนำข้อมูลดังกล่าวไปใช้เพื่อวัตถุประสงค์อย่างอื่น',
                )}
              </RemarkWrapper>
            }
            signPosition={[]}
            thead={tableHeader}
            tbody={tableBody}
          />
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxWrapper = styled.div`
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: #fff;

  @media print {
    width: 100%;
    height: 100%;

    @page {
      width: 100%;
      height: 100vh;
      margin: 1cm;
    }

    table {
      page-break-after: auto;
    }
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    td {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    thead {
      display: table-header-group;
    }
    tfoot {
      display: contents;
    }
  }
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const RowTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`
const TableTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const RemarkWrapper = styled.div`
  height: 80px;
`

export default CompareReportPDF
